import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const useHandleBooking = (service, startDate, startTime, customerName, address, email, phone, pincode, pincodePrice) => {
  const navigate = useNavigate();

  const handleBooking = async (e) => {
    e.preventDefault();
    if (!startDate || !startTime || !customerName || !address || !email || !phone) {
      toast.error("Please fill all required fields.");
      return;
    }
    if (!pincode || pincodePrice == null) {
      toast.error("Please check pin code availability before booking.");
      return;
    }

    const formatDateTime = (date, time) => {
      const dateObj = new Date(`${date}T${time}:00`);
      return dateObj.toLocaleString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
      });
    };

    const bookingData = {
      decor_service_id: service.id,
      customer_name: customerName,
      address: address,
      email: email,
      phone: phone,
      // No trailing "Z" here — startDate/startTime are the customer's local (IST) wall-clock
      // picks, so this must parse as local time before converting to a UTC instant. Appending
      // "Z" would tell JS to treat those same digits as UTC, shifting the stored time by +5:30.
      start_datetime: new Date(`${startDate}T${startTime}:00`).toISOString(),
      pincode: pincode,
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/bookings`, bookingData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 201) {
        const bookingId = response.data.id;
        const totalPrice = response.data.total_price ?? service.price + pincodePrice;
        toast.success(`Booking confirmed for ${service.name} from ${startDate} at ${startTime}`);

        const confirmationUrl = `${window.location.origin}/booking-confirmation/${bookingId}`;
        const whatsappMessage = `*New Booking Details*\n\n` +
          `➤  *Service:* ${service.name}\n` +
          `➤  *Customer Name:* ${customerName}\n` +
          `➤  *Address:* ${address}\n` +
          `➤  *Pincode:* ${pincode}\n` +
          `➤  *Email:* ${email}\n` +
          `➤  *Phone:* ${phone}\n` +
          `➤  *Start Date:* ${formatDateTime(startDate, startTime)}\n` +
          `➤  *Service Price:* ₹${service.price}\n` +
          `➤  *Service Charges (Pincode):* ₹${pincodePrice}\n` +
          `➤  *Total Price:* ₹${totalPrice}\n` +
          `➤  *Booking Details:* ${confirmationUrl}`;

        const whatsappUrl = `https://wa.me/7011676961?text=${encodeURIComponent(whatsappMessage)}`;
        window.open(whatsappUrl, "_blank");
        navigate(`/booking-confirmation/${bookingId}`);
      } else {
        toast.error("Booking failed. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      const backendMessage = error.response?.data;
      toast.error(typeof backendMessage === "string" ? backendMessage : "An error occurred. Please try again.");
    }
  };

  return { handleBooking };
};

export default useHandleBooking;
